import Link from 'next/link'
import Image from 'next/image'
import React from 'react'
import Logo from '../components/logo.png'
import { Col, Container, Row } from 'react-bootstrap'

const Footer = () => (
  <footer>
    <Container>
      <Row>
        <Col>
          <Image src={Logo} height={24} alt="app logo" />
          <small>© 2020-2021</small>
        </Col>

        <Col>
          <h5>About</h5>
          <ul className="list-unstyled text-small">
            <li>
              <Link passHref href="/privacy-policy">
                <a className="text-muted">Privacy policy</a>
              </Link>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  </footer>
)

export default Footer
